module.exports = __webpack_public_path__ + "img/7254d0886c545ad4cb3e1c6752947709.gif";